const getters = {
  testimonials: state => state.testimonial,
};

export default getters;
